  <div class='video-container'>
  <div class='video-panel'>
    <video width='900' autobuffer controls autoplay (ended)='videoEnded()' #videoPlayer>
      <source src="{{getVideoFileName()}}" type="video/mp4"> Your browser does not support HTML5 video.
    </video>
    <div class='action-panel' [@fadeInTopBig]='slideInActionPanel()'>
      <div style='text-align:center'>
        <img src='/assets/images/logo-black-2.png' style='width:75%'>
      </div>
      <div  style='text-align:center;vertical-align:bottom'>
        <div style='margin:100px'>
          <span class='button' (click)='closeDialog()'>Close</span>
          <span class='button' (click)='replayVideo()'>Replay Video</span>
        </div>
      </div>
    </div>
  </div>
</div>


